<template>
  <div id="vipDesc">
    <div class="app-name-div">
      <img src="../../assets/img/app-info-name@2x.png" alt />
      <div class="app-ba-content">VIP购买指南</div>
    </div>
    <div class="vipDesc-img">
      <img src="../../assets/img/vip-desc@2x.png" alt />
      <button @click="toPay" class="vipDesc-img-b-1">开通</button>
      <button @click="toPay" class="vipDesc-img-b-2">开通</button>
      <button @click="toPay" class="vipDesc-img-b-3">开通</button>
    </div>
    <div class="app-ba">
      <img src="../../assets/img/vip-desc-bianzu@2x.png" alt />
      <div class="app-ba-content">推荐购买永久VIP，一次购买终身使用</div>
    </div>
    <div class="app-list-desc">VIP功能全面，避免任何意外！</div>
  </div>
</template>
<script>
import headBack from "../common/head-back";

export default {
  name: "vipDesc",
  data() {
    return {
      msg: "vipDesc"
    };
  },
  methods: {
    toPay: function() {
      this.$router.push("/pay");
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.vipDesc-img {
  width: 630px;
  height: 668px;
  margin: 0 auto;
}
.vipDesc-img img {
  width: 630px;
  height: 668px;
}

.vipDesc-img button {
  width: 130px;
  height: 48px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  border-radius: 8px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 20px;
  border: none;
}

.vipDesc-img-b-1 {
  position: relative;
  left: 60px;
  top: -95px;
}
.vipDesc-img-b-2 {
  position: relative;
  left: 80px;
  top: -95px;
}
.vipDesc-img-b-3 {
  position: relative;
  left: 100px;
  top: -95px;
}

.app-name-div {
  width: 344px;
  height: 44px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0px auto 40px auto;
}

.app-name-div img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -38px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 44px;
}

.app-ba {
  width: 624px;
  height: 46px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 34px auto 20px auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

.app-list-desc {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b59991;
  line-height: 40px;
  margin: 0px auto 32px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/common/vipDesc.vue